/* eslint-disable no-use-before-define */
import React, { Children } from 'react'

import { WizardStep, WizardTitle } from './wizard.styled'

export default interface WizardProps {
  step: number
  title: string
  subSection: React.ReactNode
}

export const Wizard: React.FC<WizardProps> = (props) => {
  const { children, step, title, subSection } = props
  const maxSteps = Children.count(children)

  return (
    <>
      <WizardStep>
        Step {step} of {maxSteps}
      </WizardStep>
      <WizardTitle>{title}</WizardTitle>
      <>{subSection}</>
      <>{React.Children.toArray(children)[step - 1]}</>
    </>
  )
}

Wizard.defaultProps = {
  step: 1,
}
